const CODE_KEY = 'affiliate-signup-code'
const LOCK_KEY = 'affiliate-signup-code-locked'
const PENDING_KEY = 'affiliate-signup-pending-user'
const SOURCE_KEY = 'affiliate-signup-source'
const CHANGE_EVENT = 'affiliate-signup-change'

export const normalizeReferralCode = (value: string) => value.trim().toUpperCase()
export const isValidReferralCode = (value: string) =>
  !value.trim() || /^[A-Z0-9][A-Z0-9_-]{2,63}$/.test(normalizeReferralCode(value))
export function readReferralCode() {
  return window.sessionStorage.getItem(CODE_KEY) ?? ''
}
export function setReferralCode(value: string) {
  if (isReferralCodeLocked()) return
  window.sessionStorage.setItem(CODE_KEY, value)
  window.dispatchEvent(new Event(CHANGE_EVENT))
}
export function isReferralCodeLocked() {
  return window.sessionStorage.getItem(LOCK_KEY) === 'true'
}
export function subscribeReferralCode(listener: () => void) {
  window.addEventListener(CHANGE_EVENT, listener)
  return () => window.removeEventListener(CHANGE_EVENT, listener)
}
export function captureReferralCode() {
  const code = new URL(window.location.href).searchParams.get('referral_code')
  if (code === null) return
  const normalized = normalizeReferralCode(code)
  if (!normalized) return
  window.sessionStorage.setItem(CODE_KEY, normalized)
  window.sessionStorage.setItem(LOCK_KEY, 'true')
  window.sessionStorage.setItem(SOURCE_KEY, window.location.origin)
  window.dispatchEvent(new Event(CHANGE_EVENT))
}
export function affiliateSignupFields(code = readReferralCode()) {
  const normalized = normalizeReferralCode(code)
  return {
    ...(normalized ? { referral_code: normalized } : {}),
    signup_source: window.sessionStorage.getItem(SOURCE_KEY) || window.location.origin,
  }
}
export function markPendingAffiliateSignup(uid: string) {
  window.sessionStorage.setItem(PENDING_KEY, uid)
}
export function isPendingAffiliateSignup(uid: string) {
  return window.sessionStorage.getItem(PENDING_KEY) === uid
}
export function clearAffiliateSignup() {
  for (const key of [CODE_KEY, LOCK_KEY, PENDING_KEY, SOURCE_KEY])
    window.sessionStorage.removeItem(key)
  window.dispatchEvent(new Event(CHANGE_EVENT))
}
